import ShipmentPreview from "./ShipmentPreview";

export default ShipmentPreview;
